import { CalendarCheck, Tag } from 'lucide-react'
import type { VerticalPolicyView } from '@/lib/api/botSettings'

interface VerticalRuntimeSummaryProps {
  runtime: VerticalPolicyView['runtime']
}

/**
 * Lo que el asistente hace por defecto en este vertical. Solo lectura: son reglas
 * del producto, no ajustes del tenant.
 */
export default function VerticalRuntimeSummary({ runtime }: VerticalRuntimeSummaryProps) {
  const lines = [
    {
      key: 'closing',
      Icon: CalendarCheck,
      text: runtime.requiresAppointment
        ? 'Las citas y reservas siempre las confirma tu personal; el asistente solo registra la solicitud.'
        : 'El asistente puede cerrar la venta y pasar el pedido a tu equipo para que lo confirme.',
    },
    {
      key: 'price',
      Icon: Tag,
      text: runtime.allowPriceDiscussion
        ? 'Puede conversar sobre el precio de un producto con el cliente.'
        : 'No acepta regateo ni descuentos; sí compara los precios reales de tu catálogo.',
    },
  ]

  return (
    <section
      aria-labelledby="vertical-runtime-title"
      className="rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-900/50"
    >
      <h4 id="vertical-runtime-title" className="text-xs font-semibold text-gray-900 dark:text-gray-100">
        Cómo se comporta tu asistente en este tipo de negocio
      </h4>
      <ul className="mt-2 space-y-1.5">
        {lines.map(({ key, Icon, text }) => (
          <li key={key} className="flex items-start gap-2 text-xs text-gray-600 dark:text-gray-400">
            <Icon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-indigo-600 dark:text-indigo-400" aria-hidden="true" />
            <span>{text}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}
